import React, { useEffect, useState } from "react";
import { Image } from "antd";
import Header from "../../components/Header/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import s from "./Events.module.scss";
import "react-multi-carousel/lib/styles.css";
import {
  EnvironmentOutlined,
  ClockCircleOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import {
  getEventDetails,
  getEventPhotos,
} from "../../../../redux/LangingPageSlice";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PageTitle from "../../components/PageTitle/PageTitle";
import BackLink from "../../components/BackLink/BackLink";
import { toTitleCase } from "../../textUtils";

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1950 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1950, min: 1450 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Events = () => {
  const event = useSelector((state) => state.landing.eventDetails);
  const dispatch = useDispatch();
  const photos = useSelector((state) => state.landing.photos);
  const { width } = useWindowDimensions();
  const params = useParams();
  const [preview, setPreview] = useState({ visible: false, current: 0 });

  useEffect(() => {
    if (params.id) {
      dispatch(getEventDetails(params.id));
      dispatch(getEventPhotos(params.id));
    }
  }, [params.id]);

  return (
    <div>
      {width > 1200 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}

      <div className={s.wrapper}>
        <div className={s.container}>
          <BackLink fallback="/events">All events</BackLink>
          <PageTitle
            className={s.h2}
            eyebrow={event?.additional_title || "Events"}
            title={toTitleCase(event?.title)}
          />
          <div className={s.common_info}>
            {event?.location && (
              <div className={s.place}>
                <EnvironmentOutlined className={s.meta_icon} /> {event.location}
              </div>
            )}
            {event?.event_dates?.date && (
              <div className={s.date}>
                <ClockCircleOutlined className={s.meta_icon} />{" "}
                {event.event_dates.date}
              </div>
            )}
          </div>
          <div
            className={s.introduction}
            dangerouslySetInnerHTML={{ __html: event?.body }}
          />
          <div className={s.link}>
            <FilePdfOutlined className={s.meta_icon} /> Program of the
            conference is{" "}
            <a
              href={`/conference/Program_${params.id}_conference.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className={s.link_text}
            >
              here
            </a>
            .
          </div>
        </div>

        <div className={`${s.container} ${s.gallery}`}>
          <PageTitle
            className={s.section_title}
            eyebrow="Gallery"
            title="Photo Gallery"
          />
          <Slider {...settings}>
            {photos?.map((it, i) => (
              <div key={it.id} className={s.slider_item}>
                <img
                  src={it?.file}
                  alt=""
                  className={s.slider_img}
                  onClick={() => setPreview({ visible: true, current: i })}
                />
              </div>
            ))}
          </Slider>
          <Image.PreviewGroup
            items={(photos || []).map((it) => it.file)}
            preview={{
              rootClassName: s.lightbox,
              visible: preview.visible,
              current: preview.current,
              onVisibleChange: (visible) =>
                setPreview((p) => ({ ...p, visible })),
              onChange: (current) => setPreview((p) => ({ ...p, current })),
            }}
          />
        </div>
      </div>
      <LandingFooter />
      <ScrollToTop />
    </div>
  );
};

export default Events;
